import { useList } from '@refinedev/core';
import { FormField } from '@/components/forms';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Info } from 'lucide-react';
import type { TriggerAction } from '../../types';

interface ChannelPassFormProps {
  action: TriggerAction;
  onChange: (patch: Partial<TriggerAction>) => void;
}

/**
 * ChannelPassForm
 *
 * Форма действий деактивации/скрытия пропуска канала
 *
 * @returns {React.ReactElement} React компонент
 */
export function ChannelPassForm({ action, onChange }: ChannelPassFormProps) {
  const { result: passesResult } = useList<{ id: number; name: string }>({
    resource: 'channel-passes',
    pagination: { currentPage: 1, pageSize: 200, mode: 'server' },
  });

  const passes = passesResult.data ?? [];

  return (
    <div className="space-y-4">
      <Alert>
        <Info className="h-4 w-4" />
        <AlertDescription>
          Если пропуск не выбран, будет использован ID из данных события (channelPassId)
        </AlertDescription>
      </Alert>

      <FormField label="Пропуск канала" name="channelPassId" hint="Опционально - можно оставить пустым">
        <Select
          value={action.channelPassId ? String(action.channelPassId) : 'auto'}
          onValueChange={(v) => onChange({ channelPassId: v === 'auto' ? undefined : Number(v) })}
        >
          <SelectTrigger>
            <SelectValue placeholder="Из данных события" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="auto">Из данных события (автоматически)</SelectItem>
            {passes.map((pass) => (
              <SelectItem key={pass.id} value={String(pass.id)}>
                {pass.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FormField>
    </div>
  );
}
